import { useEffect,useState } from 'react';
import { reconciliationRequest } from '../services/bankReconciliation';

export function useBankReconciliation(account,filters) {
    const [state,setState]=useState({data:null,loading:false,error:null});
    const [version,setVersion]=useState(0);
    const query=new URLSearchParams(filters).toString();
    useEffect(()=>{
        if(!account){setState({data:null,loading:false,error:null});return;}
        const controller=new AbortController();
        setState({data:null,loading:true,error:null});
        reconciliationRequest(account,`?${query}`,undefined,controller.signal)
            .then(data=>{if(!controller.signal.aborted)setState({data,loading:false,error:null});})
            .catch(e=>{if(!controller.signal.aborted)setState({data:null,loading:false,error:e.message});});
        return ()=>controller.abort();
    },[account,query,version]);
    return {...state,refresh:()=>setVersion(v=>v+1)};
}
